import { css } from '@emotion/css';

export const inputStyles = css`
  &.MuiInputBase-root.Mui-error {
    border-color: var(--border-error-dark);
  }

  &.Mui-disabled .MuiInputBase-input {
    color: var(--text-placeholder);
  }

  .MuiInputBase-input::placeholder {
    opacity: 1;
  }
`;

export const minHeight40 = css`
  min-height: 4rem;
`;

export const minHeight48 = css`
  min-height: 4.8rem;
`;

export const py11 = css`
  padding-top: 1.1rem;
  padding-bottom: 1.1rem;
`;
